<template>
  <div class="group-challenge-signup-base">
    <riseup-header/>
    <div class="header">
      <div class="headline">{{ headline }}</div>
      <div class="description">{{ description }}</div>
    </div>
    <img :src="require('@/assets/challenge/RoundBottom.svg')" class="ellipse">
    <div class="body">
      <slot name="body"></slot>
    </div>
    <div class="button-wrapper">
      <riseup-button class="cta-button" :title="ctaButtonTitle" :action="ctaButtonAction"/>
    </div>
  </div>
</template>

<script>

import BaseUI from 'base-ui';
import RiseupHeader from '@/base-components/app-header/RiseupHeader';

export default {
  name: 'GroupChallengeSignupBase',
  components: {
    RiseupButton: BaseUI.RiseupButton,
    RiseupHeader,
  },
  props: {
    headline: {
      type: String,
      required: true,
    },
    description: {
      type: String,
    },
    ctaButtonTitle: {
      type: String,
    },
    ctaButtonAction: {
      type: Function,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';
@import '../../../../../scss/mixins';

  .group-challenge-signup-base {
    .header {
      @include responsive-padding;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 24px;
      background-color: $riseup_blue;
      color: $riseup_white;
      text-align: center;
      .headline {
        margin-top: 15px;
        font-weight: bold;
        font-size: 24px;
      }
      .description {
        margin-top: 16px;
        font-size: 18px;
        line-height: 140%;
        white-space: pre-line;
      }
    }
    .ellipse {
      width: 100%;
    }
    .body {
      @include responsive-padding;
      margin-top: 24px;
      font-size: 18px;
      font-family: SimplerPro;
      line-height: 140%;
    }
    .button-wrapper {
      margin: 30px 0;
      @include responsive-padding;
      .cta-button {
        width: 100%;
        height: 60px;
      }
    }
  }

</style>
